import { Box, CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";
import { ServiceProvider, useTheme } from "contexts";
import { ThemeProvider } from "@mui/material/styles";
import { Themes } from "utils";
import { Common } from "components";

export const DefaultLayout = () => {
  const { theme } = useTheme();

  return (
    <ThemeProvider theme={Themes.defaultTheme(theme)}>
      <CssBaseline />
      <ServiceProvider>
        <Box
          component="div"
          sx={{
            position: "relative",
            minHeight: "100vh",
            backgroundColor: theme.color.background.color,
            color: theme.color.font.color,
            overflowX: "clip",
          }}
        >
          {/* Animated Space & Celestial Meteor Shower Background */}
          <Common.SpaceBackground />

          <Common.Navbar />
          {/* <Common.Sidebar /> */}
          <Box component="main" sx={{ position: "relative", zIndex: 1 }}>
            <Outlet />
          </Box>
          <Common.Footer />
        </Box>
      </ServiceProvider>
    </ThemeProvider>
  );
};
